<template>
  <div class="container__grid">
    <div class="container__grid__main">
      <router-view />
    </div>
    <div class="container__grid__menu">
      <Menu />
    </div>
    
  </div>
</template>


<script>
import Menu from "../components/Menu/Menu";

export default {
  components: { Menu },

}
</script>
<style scoped>
.container__grid {
  grid-template: "grid_menu" "grid_main" "grid_footer";
  min-height: 100vh;
  display: grid;
  grid-template-rows: auto 1fr auto;
}

.container__grid__main {
  grid-area: grid_main;
  margin-top: 2.5rem;
  background-color: var(--color-background);
}

.container__grid__menu {
  grid-area: grid_menu;
  position: fixed;
  background-color: white;
  height: 2.5rem;
  width: 100%;
}
</style>